import React from 'react'

export function Send(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  return <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M5 12L4.39589 6.56299C4.22297 5.0067 5.82469 3.86433 7.23983 4.53465L19.1842 10.1925C20.7093 10.9149 20.7093 13.0851 19.1842 13.8075L7.23983 19.4653C5.82469 20.1357 4.22297 18.9933 4.39589 17.437L5 12ZM5 12H12" stroke="currentStroke" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
}
